export function Eventify(el, object) {
	console.log(`Eventify()`);
	const eventLink = function(el, event, object, method) {
		el.addEventListener(event, evt=>{
			object[method].call(object, evt);
		});
	}
	const eventify = function(e) {
		const pairs = e.getAttribute(`data-event`).split(`;`);
		for (let p of pairs) {
			let [event,method] = p.trim().split(`:`).map( m=>m.trim() );
			for (const evt of event.split(`,`).map( et=>et.trim() )) {
				if (!method) {
					method = evt;
				}
				eventLink(e, evt, object, method);
			}
		}
	};
	if (`function`==typeof el.hasAttribute && el.hasAttribute(`data-event`)) {
		eventify(el);
	}
	for (const e of el.querySelectorAll(`[data-event]`)) eventify(e);
}